import { useStore, useDispatch } from 'react-redux';
import G from './Getters';
import A from './ActionCreators.js';
import PersonFolder from './svg/PersonFolder.svg';

export default function TargetUserSelector(){


  const dispatch = useDispatch();

  const store = useStore();
  
  const state = store.getState();


  const members = G.getGroupMembersInfo(state);

  const options = Object.keys(members); 
  const thisUserId = G.getUserId(state);

  const currentWorkspace = G.getCurrentWorkspaceInfo(state);
  let { groupId, userId } = currentWorkspace;

  return (

    <div style={{
      flexWidth:'50%',
        paddingRight:10,

      borderLeft:'1px solid #ccc',
      }} class="sg-row v-center flex-expand">
      
      <img style={{width:20}} src={PersonFolder}/>
        <select class="flex-expand" style={{
          border:'none',
        }} onChange={e => {

          dispatch(A.setCurrentWorkspace({
            groupId,
            userId:e.target.value,
          }))

        }} defaultValue={thisUserId} value={userId||thisUserId}>
        {options.map(opt => <option value={opt}>{opt}</option>)}
      </select>

    </div>
  )


}
